export default "__VITE_ASSET__c2f30dcc__"